var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcc3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    fill: "#110F14",
    stroke: "#36333C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4084 13.5982C11.43 13.3862 11.3489 13.1765 11.1907 13.0336L9.57704 11.0899V10.7998H14.5869L18.459 19.2923L21.8634 10.7998H26.6394V11.0902L25.26 12.4128C25.141 12.5035 25.0822 12.6524 25.1068 12.8V22.5183C25.0822 22.6658 25.141 22.8147 25.26 22.9054L26.6071 24.228V24.5185H19.8307V24.228L21.2264 22.8732C21.3637 22.736 21.3637 22.6958 21.3637 22.4861V14.6306L17.483 24.4859H16.9586L12.4409 14.6306V21.2359C12.4033 21.5137 12.4954 21.7932 12.6911 21.9939L14.5062 24.1955V24.4859H9.35938V24.1958L11.1744 21.9939C11.3685 21.7929 11.4556 21.5114 11.4084 21.2359V13.5982Z",
    fill: "#F9F7FC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcc3);
export default __webpack_public_path__ + "static/media/icc3.162ee4be336999b8d50507934a409622.svg";
export { ForwardRef as ReactComponent };